// Types
import type { IIdealTerrainProps } from "./types";

export function IdealTerrain({infocusID, batches,batchesCompletions}: IIdealTerrainProps) {

    return (<div data-infocusID={infocusID === 13}
        className="md:absolute
            print:!relative
            print:!left-0
            border-[1px] border-r-[#000]
            last-of-type:border-none
            opacity-100 -left-[100%]
            data-[inFocusID=true]:opacity-0
            data-[inFocusID=true]:left-0
            transition-all duration-[0.38s]
            w-full h-screen flex flex-col justify-between gap-4 p-16 bg-white
            page-break
        "
    >
            <div className="w-[60%] flex flex-col justify-between gap-16 py-16">
                <span className="w-full h-auto flex flex-col gap-4">
                    <span className="text-5xl">Sugestão de escolha do terreno (Por I.A)</span>
                </span>

                <span className="text-gris-200 text-xl flex flex-col gap-3">
                    {
                        batchesCompletions?.choices[0].message.content?.split('\n\n').map((d, i) => (<span key={i} className="flex">{d}</span>))
                    }
                </span>
            </div>

            <span className="w-full flex-1 flex flex-row flex-nowrap items-center justify-between gap-4">
                <span className="flex flex-1 max-w-[70%] h-full">
                    <span className="w-full h-full flex flex-col gap-0">
                        <span className="w-full h-12 flex flex-row flex-nowrap items-center justify-center">
                            <span className="flex flex-nowrap items-center justify-center p-6 bg-[#cde9e1] flex-1 font-semibold first-of-type:border-l-[2px]  border-b-[2px] border-t-[2px] border-r-[2px] border-black">Módulo</span>
                            <span className="flex flex-nowrap items-center justify-center p-6 bg-[#cde9e1] flex-1 font-semibold border-t-[2px] border-b-[2px] border-r-[2px] border-black">Quadra/Lote</span>
                            <span className="flex flex-nowrap items-center justify-center p-6 bg-[#cde9e1] flex-1 font-semibold border-t-[2px] border-b-[2px] border-r-[2px] border-black">Área (m²)</span>
                            <span className="flex flex-nowrap items-center justify-center p-6 bg-[#cde9e1] flex-1 font-semibold border-t-[2px] border-b-[2px] border-r-[2px] border-black">Valor total</span>
                            <span className="flex flex-nowrap items-center justify-center p-6 bg-[#cde9e1] flex-1 font-semibold border-t-[2px] border-b-[2px] border-r-[2px] border-black">R$/m²</span>
                            <span className="flex flex-nowrap items-center justify-center p-6 bg-[#cde9e1] flex-1 font-semibold border-t-[2px] border-b-[2px] border-r-[2px] border-black">Frente(m)</span>
                            <span className="flex flex-nowrap items-center justify-center p-6 bg-[#cde9e1] flex-1 font-semibold border-t-[2px] border-b-[2px] border-r-[2px] border-black">Lateral(m)</span>
                            <span className="flex flex-nowrap items-center justify-center p-6 bg-[#cde9e1] flex-1 font-semibold border-t-[2px] border-b-[2px] border-r-[2px] border-black">Fundo(m)</span>
                        </span>
                        <span className="w-full flex-1 flex flex-col mt-2">
                            {
                                batches.map((batche, index) => (
                                    <span key={batche.id} data-idealbatch={batchesCompletions?.choices[0].message.content?.includes(batche.name)} className="w-full h-auto flex flex-row flex-nowrap data-[idealbatch=true]:bg-[#9cd3c3] hover:bg-[#9cd3c3]">
                                        <span data-first={index === 0} className="max-w-[50%] flex flex-nowrap items-center justify-center p-6 flex-1 font-semibold data-[first=true]:border-t-[0px] first-of-type:border-l-[2px]  border-b-[2px] border-t-[2px] border-r-[2px] border-black">
                                            {
                                                batche.name
                                            }
                                        </span>
                                        <span data-first={index === 0} className="max-w-[50%] flex flex-nowrap items-center justify-center p-6 flex-1 font-semibold data-[first=true]:border-t-[0px] first-of-type:border-l-[2px]  border-b-[2px] border-t-[2px] border-r-[2px] border-black">
                                            {
                                                batche.batch
                                            }
                                        </span>
                                        <span data-first={index === 0} className="max-w-[50%] flex flex-nowrap items-center justify-center p-6 flex-1 font-semibold data-[first=true]:border-t-[0px] first-of-type:border-l-[2px]  border-b-[2px] border-t-[2px] border-r-[2px] border-black">
                                            {
                                                batche.area
                                            }m²
                                        </span>
                                        <span data-first={index === 0} className="max-w-[50%] flex flex-nowrap items-center justify-center p-6 flex-1 font-semibold data-[first=true]:border-t-[0px] first-of-type:border-l-[2px]  border-b-[2px] border-t-[2px] border-r-[2px] border-black">
                                            {
                                                Intl.NumberFormat("pt-BR", {
                                                    style: 'currency',
                                                    currency: 'BRL'
                                                }).format(batche.amount)
                                            }
                                        </span>
                                        <span data-first={index === 0} className="max-w-[50%] flex flex-nowrap items-center justify-center p-6 flex-1 font-semibold data-[first=true]:border-t-[0px] first-of-type:border-l-[2px]  border-b-[2px] border-t-[2px] border-r-[2px] border-black">
                                            {
                                                Intl.NumberFormat("pt-BR", {
                                                    style: 'currency',
                                                    currency: 'BRL'
                                                }).format(batche.square_meter)
                                            }/m²
                                        </span>
                                        <span data-first={index === 0} className="max-w-[50%] flex flex-nowrap items-center justify-center p-6 flex-1 font-semibold data-[first=true]:border-t-[0px] first-of-type:border-l-[2px]  border-b-[2px] border-t-[2px] border-r-[2px] border-black">
                                            {
                                                batche.front
                                            }m²
                                        </span>
                                        <span data-first={index === 0} className="max-w-[50%] flex flex-nowrap items-center justify-center p-6 flex-1 font-semibold data-[first=true]:border-t-[0px] first-of-type:border-l-[2px]  border-b-[2px] border-t-[2px] border-r-[2px] border-black">
                                            {
                                                batche.side
                                            }m²
                                        </span>
                                        <span data-first={index === 0} className="max-w-[50%] flex flex-nowrap items-center justify-center p-6 flex-1 font-semibold data-[first=true]:border-t-[0px] first-of-type:border-l-[2px]  border-b-[2px] border-t-[2px] border-r-[2px] border-black">
                                            {
                                                batche.bottom
                                            }m²
                                        </span>
                                    </span>
                                ))
                            }
                        </span>
                    </span>
                </span>
                {/* <span className="flex flex-1 max-w-[50%] h-full bg-red-500"></span>                         */}
            </span>

            <span className="text-gray-400 text-xl text-center">
                Os valores informados acima foram gerados pelo <span className="font-bold text-[#079269] cursor-default select-none">Harvey I.A</span>
            </span>
        </div>
    )
}
